class CodeBlock extends React.Component {
  constructor() {
    super();
  }

  render () {
    return(
      <div className="code-block">
        <h5 className="lang">{this.props.lang.toUpperCase()}</h5>
        <pre>
          <code className={`language-${this.props.lang}`}>
            {this.props.children}
          </code>
        </pre>
      </div>
    );
  }
}
